import ErrorBoundary from './ErrorBoundary';

export { ErrorFallback, RouteErrorBoundary } from './ErrorBoundary';
export default ErrorBoundary;
